<template>
  <div>
    <p class="text-caption text-center">
      <span class="fakeLink" @click="$router.push({ name: 'Eula' })"
        >Termos de uso (EULA)</span
      >
    </p>
    <p class="text-caption text-center">
      <span class="fakeLink" @click="$router.push({ name: 'Privacy' })"
        >Termos e Políticas de privacidade</span
      >
    </p>
    <p class="text-caption text-center">
      © {{ new Date().getFullYear() }} Copyright © 2023 G.E. Sabiá -Testes.
      Todos os direitos reservados
      <span class="font-weight-bold">v{{ version }}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'Copyright',
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  activated() {},
  methods: {},
  computed: {},
};
</script>
